import axios from 'axios';
import * as endpoint from '../../../endpoint';
// import * as actionTypes from '../../../actionTypes';
import { consolelog, delCancelToken } from '../../../../lib/tools';
import { createCancelToken, handleErrorResponse } from '../../apis';
import { configureAxiosForJSON } from '../../axiosConfig';
import { SUCCESS_API_GET_GROUP } from '../../../actionTypes';

/**
 * 指定したグループの詳細情報を取得する
 * @param {*} apiToken
 * @param {*} apiParams
 * @returns
 */
const getGroup = (apiToken, apiParams, groupId) => dispatch => {
  consolelog('[API CALL] getGroup()');

  configureAxiosForJSON(apiToken);
  const url = endpoint.API_GET_GROUP.replace('{groupId}', groupId);
  const { cancelToken, cancelTokenKey } = createCancelToken('getGroup');
  const params = { cancelToken, apiParams };

  return axios
    .get(url, params)
    .then(res => {
      dispatch({ type: SUCCESS_API_GET_GROUP, payload: res.data });
    })
    .catch(thrown => {
      if (!axios.isCancel(thrown)) {
        handleErrorResponse(thrown, dispatch);
        dispatch();
      }
    })
    .finally(() => {
      delCancelToken(cancelTokenKey);
    });
};

export default getGroup;
